export default __webpack_public_path__ + "static/media/tea.1475fcae.png";